import styled from "styled-components";

import ReactSlider from "react-slider";

interface IStyledTrack {
  index: number;
}

interface ICategoryCard {
  $isSelected: boolean;
}

export const Container = styled.div`
  padding: 48px 16px;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 48px;
  }
`;

export const DefaultWrapper = styled.div`
  color: ${({ theme }) => theme.palette.primary.blue900};
  font-family: "Plus Jakarta Sans", sans-serif;
  margin-top: 32px;
  padding-bottom: 32px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.blue50};
`;

export const DefaultTitle = styled.h6`
  font-size: ${16 / 16}rem;
  font-weight: 700;
`;

export const TitleCloseWrapper = styled.div`
  display: flex;
  gap: 8px;
  color: ${({ theme }) => theme.palette.primary.blue900};

  svg {
    width: ${40 / 16}rem;
    height: ${40 / 16}rem;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.palette.primary.blue50};
    cursor: pointer;
  }
`;
export const Title = styled.h4`
  margin-right: auto;
  font-size: ${24 / 16}rem;
  font-weight: 700;
  font-family: "Plus Jakarta Sans", sans-serif;
`;

export const CategoriesCardsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap; 
  gap: 4px;
  margin-top: 12px;
  margin-bottom: 8px;
`;

export const CategoryCard = styled.div<ICategoryCard>`
  border-radius: 8px;
  font-size: ${14 / 16}rem;
  font-weight: 500;
  font-family: "Plus Jakarta Sans", sans-serif;
  padding: 10px 16px;
  width: calc(50% - 2px); 
  white-space: nowrap;
  cursor: pointer;
  text-align: center;

  background-color: ${({ $isSelected, theme }) =>
    $isSelected ? theme.palette.primary.blue500 : "white"};

  color: ${({ $isSelected }) => ($isSelected ? "white" : "currentcolor")};

  border: 1px solid
    ${({ $isSelected }) => ($isSelected ? "transparent" : "rgb(78, 118, 181)")};

  font-weight: ${({ $isSelected }) => ($isSelected ? 700 : 500)};

   &:hover {
     transform: translateY(-2px);
     transition: 0.5s;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  }
  
`;

export const SliderContainer = styled.div`
  margin-top: 32px;

  h3 {
    font-size: ${16 / 16}rem;
    font-weight: 700;
    font-family: "Plus Jakarta Sans", sans-serif;
    color: ${({ theme }) => theme.palette.primary.blue900};
  }
`;

export const CharacteristicNameValueWrapper = styled.div`
  display: flex;
  margin-top: 16px;
  gap: 12px;

  svg {
    cursor: pointer;
    width: ${24 / 16}rem;
    height: ${24 / 16}rem;
    color: white;
    border-radius: 50%;
    padding: 4px;
    background-color: rgb(229, 231, 235);

    &.active {
      background-color: ${({ theme }) => theme.palette.primary.blue500};
    }
  }
`;

export const CharacteristicName = styled.p`
  margin-right: auto;
  font-size: ${16 / 16}rem;
`;

export const CharacteristicValue = styled.p`
  font-weight: 700;
  font-size: ${16 / 16}rem;
`;

export const ValuesToSearch = styled.p`
  font-size: 12px;

  text-align: center;

  align-self: center;

  margin: 20px 0 12px;
`;

export const StyledSlider = styled(ReactSlider)`
  width: 100%;
  height: 8px;

  margin: 8px 0;
`;

export const StyledThumb = styled.div`
  height: 12px;
  width: 12px;
  background-color: #6ea5ff;
  border-radius: 50%;
  cursor: grab;
`;

export const StyledTrack = styled.div<IStyledTrack>`
  top: 0;
  bottom: 0;
  margin-top: 4px;
  background: ${(props) =>
    props.index === 2 ? "#999999" : props.index === 1 ? "#6EA5FF" : "#999999"};
`;

export const TotalCheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  margin: 16px auto 0;

  > input {
    color: #b6b6b6;
  }

  > label {
    margin-left: 12px;

    font-size: 14px;

    cursor: pointer;
  }
`;

export const InputsWrapper = styled.div`
  display: flex;
  gap: 48px;
  margin-top: 32px;
`;

export const InputWrapper = styled.div`
  width: calc(50% - 24px);
`;

export const InputLabel = styled.label`
  font-size: ${16 / 16}rem;
  font-weight: 500;
  font-family: "Plus Jakarta Sans", sans-serif;
  color: ${({ theme }) => theme.palette.primary.blue900};
`;

export const InputField = styled.input<{ $hasError?: boolean }>`
  border-radius: 8px;
  font-size: ${18 / 16}rem;
  font-weight: 700;
  border: 1px solid
    ${({ theme, $hasError }) =>
      $hasError ? theme.palette.error.red : theme.palette.primary.blue700} !important;
  padding: 8px 32px;
  margin-top: 8px;
  color: ${({ theme }) => theme.palette.primary.blue900};
  font-family: "Plus Jakarta Sans", sans-serif;
  max-width: 100%;
  box-sizing: border-box;
  &:focus {
    border: 1px solid ${({ theme }) => theme.palette.primary.blue500} !important;
    background: ${({ theme }) => theme.palette.primary.blue50};
  }
  &:hover{
    background: ${({ theme }) => theme.palette.primary.blue50};
  }
`;

export const RangeErrorMessage = styled.p`
  margin: 8px 0 0;
  font-size: ${14 / 16}rem;
  color: ${({ theme }) => theme.palette.error.red};
  font-family: "Plus Jakarta Sans", sans-serif;
`;

export const PropertyBenefitsContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 16px;
  > label {
    margin-left: 8px;
  }
`;

export const ButtonsContainer = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
`;
